export const commonColumns = [
    'ITEM', 'SECTOR', 'LONG_NAME', 'INSTRUMENT_TYPE',
];

export const tickerColumns = [
    'ITEM', 'LONG_NAME', 'SECURITYNAME', 'LAST', 'LASTNZ', 'CHANGE', 'CHANGE_PCT',
    'SECTOR', '_DELAY', 'CLOSE_BEGIN_1DAY', 'sector_close_time', 'sector_open_time',
    'TIME', 'LOW', 'HIGH', 'OPEN', 'CURRENCY', 'TURNOVER', 'VOLUME', 'INSTRUMENT_TYPE',
    'MARKET_CAP_ROUNDED', 'CLOSE_CA_BEGIN_1DAY', 'BASE_Y', 'VOLATILITY_3M', 'BETA_1Y',
    'TOTAL_SHARES', 'TARGET_PRICE_MEDIAN', 'RECOM_BUY', 'RECOM_OVERWEIGHT',
    'RECOM_HOLD', 'RECOM_UNDERWEIGHT', 'RECOM_SELL', 'MEDIAN_EPS_YP1',
    'MEDIAN_SALES_YP1', 'MEDIAN_NET_ASSETS_YP1', 'P_E_YP1', 'MARKET_CAP_SALES_YP1',
    'EBITDA_MEDIAN_YP1', 'ENTERPRISE_VALUE_YP1', 'MEDIAN_EPS_Y', 'MEDIAN_SALES_Y',
    'MEDIAN_NET_ASSETS_Y', 'P_E_Y', 'MARKET_CAP_SALES_Y', 'EBITDA_MEDIAN_Y',
    'ENTERPRISE_VALUE_Y', 'MEDIAN_EPS_YM1', 'MEDIAN_SALES_YM1',
    'MEDIAN_NET_ASSETS_YM1', 'P_E_YM1', 'MARKET_CAP_SALES_YM1', 'EBITDA_MEDIAN_YM1',
    'ENTERPRISE_VALUE_YM1', 'ISIN', 'GICS_CODE', 'TOTAL_NUMBER_OF_SHARES', 'BID', 'ASK',
    'CHANGE_7DAYS', 'CHANGE_7DAYS_PCT', 'CHANGE_MONTH', 'CHANGE_MONTH_PCT',
    'CHANGE_YEAR', 'CHANGE_YEAR_PCT', 'CHANGE_1YEAR', 'CHANGE_1YEAR_PCT',
    'CHANGE_5YEARS', 'CHANGE_5YEARS_PCT', 'TOP_TOTAL', 'TOP_POSITION_TIME',
    'TOP_INVESTOR_1', 'TOP_INVESTOR_2', 'TOP_INVESTOR_3', 'TOP_INVESTOR_4',
    'TOP_INVESTOR_5', 'TOP_INVESTOR_6', 'TOP_INVESTOR_7', 'TOP_INVESTOR_8',
    'TOP_INVESTOR_9', 'TOP_INVESTOR_10', 'TOP_POSITION_SHARES_1',
    'TOP_POSITION_SHARES_2', 'TOP_POSITION_SHARES_3', 'TOP_POSITION_SHARES_4',
    'TOP_POSITION_SHARES_5', 'TOP_POSITION_SHARES_6', 'TOP_POSITION_SHARES_7',
    'TOP_POSITION_SHARES_8', 'TOP_POSITION_SHARES_9', 'TOP_POSITION_SHARES_10',
    'TOP_INVESTOR_ACCOUNT_TYPE_1', 'TOP_INVESTOR_ACCOUNT_TYPE_2',
    'TOP_INVESTOR_ACCOUNT_TYPE_3', 'TOP_INVESTOR_ACCOUNT_TYPE_4',
    'TOP_INVESTOR_ACCOUNT_TYPE_5', 'TOP_INVESTOR_ACCOUNT_TYPE_6',
    'TOP_INVESTOR_ACCOUNT_TYPE_7', 'TOP_INVESTOR_ACCOUNT_TYPE_8',
    'TOP_INVESTOR_ACCOUNT_TYPE_9', 'TOP_INVESTOR_ACCOUNT_TYPE_10',
];

export const feedColumns = [
    'LONG_NAME',
    'SECURITYNAME',
    'TIME',
    'CLOSE_CA_BEGIN_1DAY',
    'CLOSE_BEGIN_1DAY',
    'ITEM',
    'SECTOR',
    'LAST',
    'LASTNZ',
    'LASTNZ_DIV',
    'CHANGE',
    'CHANGE_PCT',
    'CHANGE_7DAYS',
    'CHANGE_7DAYS_PCT',
    'CHANGE_MONTH',
    'CHANGE_MONTH_PCT',
    'CHANGE_1YEAR',
    'CHANGE_1YEAR_PCT',
    'CHANGE_3YEARS',
    'CHANGE_3YEARS_PCT',
    'CHANGE_5YEARS',
    'CHANGE_5YEARS_PCT',
];

export const fundColumns = [
    'ITEM',
    'SECTOR',
    'FUNDMGRNAME',
    'SECURITYNAME',
    'PRICE',
    'QUOTATIONCURRENCY',
    'PRICECHANGEPCT',
    'RET1WEEK',
    'RET1M',
    'RET6M',
    'RETGAVG1YR',
    'RETGAVG3YR',
    'RETGAVG5YR',
    'RETGAVG10YR',
    'TIME',
    'SECURITYTYPEID',
    'INSTRUMENT_TYPE',
];

export function getTickerColumns(type) {
    switch (type) {
    case 'SHARES':
        return tickerColumns;

    case 'FUNDS':
        return fundColumns;

    case 'COMMON':
        return commonColumns;

    default:
        return tickerColumns;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/service/tickercolumns.js
 **/